/* 🤖 this file was generated by svg-to-ts*/
export const icoYattaBranded: {
  name: 'yatta-branded';
  data: string;
} = {
  name: 'yatta-branded',
  data: `<svg width="360" height="360" viewBox="0 0 360 360" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_423_285)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M120.451 206.542C113.676 164.85 234.603 175.304 220.07 215.257C213.734 232.678 201.148 267.247 197.093 278.358C193.038 289.469 179.934 300.758 162.532 299.236C145.13 297.713 134.087 283.812 132.099 272.672C130.111 261.525 122.15 217 120.451 206.542Z" fill="#0BEBE9"/>
  <path d="M200.838 218.177C135.675 229.667 73.3128 186.001 61.8228 120.838L101.215 113.892C108.875 157.334 150.449 186.445 193.892 178.785C231.904 172.082 258.943 139.414 259.977 102.249C260.242 92.7426 266.975 84.6642 276.34 83.0128L276.736 82.943C288.994 80.7816 300.265 90.3328 299.981 102.776C298.703 158.771 258.058 208.087 200.838 218.177Z" fill="url(#paint0_linear_423_285)"/>
  <path d="M180 160C207.614 160 230 137.614 230 110C230 82.3858 207.614 60 180 60C152.386 60 130 82.3858 130 110C130 137.614 152.386 160 180 160Z" fill="#202EFF"/>
  </g>
  <defs>
  <linearGradient id="paint0_linear_423_285" x1="61.8228" y1="151.324" x2="299.986" y2="151.324" gradientUnits="userSpaceOnUse">
  <stop offset="0.13" stop-color="#0BEBE9"/>
  <stop offset="0.2296" stop-color="#0DD9EB"/>
  <stop offset="0.4306" stop-color="#12A8F1"/>
  <stop offset="0.7121" stop-color="#1B5CFA"/>
  <stop offset="0.87" stop-color="#202EFF"/>
  </linearGradient>
  <clipPath id="clip0_423_285">
  <rect width="360" height="360" fill="white"/>
  </clipPath>
  </defs>
  </svg>`
};
